export default "__VITE_ASSET__DAzGAuGK__"